import React from 'react';

const PremiumBanner = ({ clickedTryPremium }) => (
  <div className="premium-banner">
    <a onClick={clickedTryPremium}>Try Buoyweather Premium for free</a>
  </div>
  );

export default PremiumBanner;



// WEBPACK FOOTER //
// ./src/components/PremiumBanner/PremiumBanner.js